<h1 class="headline-1-bold" matDialogTitle>{{data.title}}</h1>
<div [innerHTML]="data.text" mat-dialog-content></div>
<div class="pt-24" style="width: 100%;" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="16px">
    <button *ngIf="!data.hideCancel" (click)="closeDialog(false)" color="accent" mat-stroked-button class="text-wrap">
        {{data?.cancelBtnText || 'Cancel'}}
    </button>
    <button (click)="closeDialog(true)" color="accent" mat-raised-button class="text-wrap">
        {{data?.okBtnText || 'OK'}}
    </button>
</div>